import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nextcloud'
})
export class NextcloudPipe implements PipeTransform {

  transform(value: string): string {
    if(value){
      return value
        .replace(/_/g, " ")
        .replace(/%20/g, " ")
        .replace(/%2c/g, ",")
        .replace(/%c3%bc/g, "ü")
        .replace(/%c3%a4/g, "ä");
    }
    return null;
  }

}
